<template>
  <div class="check">
    <a :href="PCUrl" class="go-back">返回首页</a>
    <div class="top">
        <img src="../assets/logo.png" alt="">
        <p>PIMC评估您的沟通状态</p>
    </div>
    <div class="box">
      <div class="left">
        <h2>欢迎您进入PIMC沟通训练反馈系统，我们会进行4个问题的评测；时间为6分钟。</h2>
        <h2>为了确保沟通顺畅，请先进行设备测试。</h2>
        <div class="text">
          <p style="margin-bottom:8px;"><img src="../assets/camera.png">摄像头注意事项</p>
          <p>1. 请保持摄像头设备连接正常，并已开启</p>
          <p>2. 请尽量保持摄像头设备干净，无其他东西遮挡</p>
          <p>3. 检测视频画面时，请保持头部正对着摄像头前方</p>
          <p style="margin:8px 0;"><img src="../assets/microphone.png">麦克风注意事项</p>
          <p>1. 请保持音频设备正常，调大音量</p>
          <p>2. 检测音频时，请说普通话，越清晰越好</p>
          <p style="margin:8px 0;"><img src="../assets/microphone.png">录制环境注意事项</p>
          <p>1.请选择安静、不被打扰的环境</p>
          <p>2. 请在光线明亮的环境下录制，避免光线过暗、曝光过度、背光。</p>
        </div>
      </div>
      <div class="right">
        <video autoplay id="camera" class="video" muted></video>
        <!-- <button id="start">开始</button>
        <button id="stop">停止</button>
        <video id="v" controls autoplay></video> -->
        <div>
          <h3><img src="../assets/check.png">{{checkText}}</h3>
          <div class="device-tip">
            <h4 :class="{usable:videoUse}"><img :src="videoUse?require('../assets/camera-active.png'):require('../assets/camera.png')">{{videoCheckText}}</h4>
            <h4 :class="{usable:audioUse}"><img :src="audioUse?require('../assets/microphone-active.png'):require('../assets/microphone.png')">{{audioCheckText}}</h4>
          </div>
        </div>
        <button id="enterRecord" class="btn" :class="{enter:videoUse&&audioUse}" :disabled='!videoUse||!audioUse' @click="goRecord">直接进入视频沟通</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      checkText:'录制设备检测中...',
      videoUse: null,
      videoCheckText:'',
      audioUse: null,
      audioCheckText:'',
      encrypt:this.$route.query.e||'',
      pimcencypt:localStorage.pimcencypt||'',
      userMessage:this.$route.query.u||'',
      realname: '',
      oldMobile: localStorage.CmindLoginMobile||123,
      mobile:'',
      realname: '',
      scene_id:'',
    }
  },
  mounted(){
    var chunks = [],arr = [];
    navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
      if (navigator.getUserMedia) {
        navigator.getUserMedia(
          {audio: true,video: true},
          (stream)=>{
            var video = document.querySelector('#camera');
            video.srcObject = stream;
            var recorder = new MediaRecorder(stream)
            $('#start').click(()=>{
              recorder.start(1000);
            })
            $('#stop').click(()=>{
              recorder.stop();
            })
            recorder.onstop=()=>{
              let blob = new Blob(chunks, {type: 'video/mp4'});
              document.querySelector('#v').src=URL.createObjectURL(blob);
              console.log('end:',blob)
            }
            let size = 0
            recorder.ondataavailable = e => {
              chunks.push(e.data);
              size+=e.data.size
              arr.push(e.data)
              if(size>200000){
                size=0
                let blob = new Blob(arr, {type: 'video/mp4'});
                console.log(blob)
                arr=[]
              }
            }
          },
          ()=>{//设备检测出错
            
          }
        );
        // 先检测摄像头设备
        navigator.getUserMedia({video: true},()=>{
            this.videoUse =  true;
            this.videoCheckText = '摄像头画面正常';
            if(this.audioUse)
                this.checkText = '设备检测成功'
        },(err)=>{
            this.videoUse =  false;
            this.checkText = '摄像头设备出错'
            //摄像头文字：
            if(err.name=='NotFoundError'||err.name=='DevicesNotFoundError')
                this.videoCheckText = '没有找到摄像头';
            else if(err.name=='NotReadableError'||err.name=='TrackStartError')
                this.videoCheckText = '摄像头被占用';
            else if(err.name=='OverconstrainedError'||err.name=='ConstraintNotSatisfiedError')
                this.videoCheckText = '摄像头不支持运转';
            else if(err.name=='NotAllowedError'||err.name=='ConstraintNotSatisfiedError')
                this.videoCheckText = '摄像头访问设备';
            else
                this.videoCheckText = '摄像头出错';
        })
        // 再检测音频设备
        navigator.getUserMedia({audio: true},()=>{
            this.audioUse =  true;
            this.audioCheckText = '麦克风正常';
            if(this.videoUse)
                this.checkText = '设备检测成功'
        },(err)=>{
            this.audioUse = false;
            if(this.videoUse==false)
                this.checkText = '设备出错'
            else if(this.videoUse)
                this.checkText = '音频设备出错'
            //
            if(err.name=='NotFoundError'||err.name=='DevicesNotFoundError')
                this.audioCheckText = '没有找到音频设备';
            else if(err.name=='NotReadableError'||err.name=='TrackStartError')
                this.audioCheckText = '音频设备被占用';
            else if(err.name=='OverconstrainedError'||err.name=='ConstraintNotSatisfiedError')
                this.audioCheckText = '音频设备不支持运转';
            else if(err.name=='NotAllowedError'||err.name=='ConstraintNotSatisfiedError')
                this.audioCheckText = '音频拒绝访问设备';
            else
                this.audioCheckText = '音频设备出错';
        })
      }else{
        this.checkText = '浏览器不支持使用设备'
        alert('浏览器不支持使用设备')
      }
  },
  created(){
    if(!this.encrypt){
      this.login()
    }
  },
  methods:{
    goRecord(){
      if(this.encrypt)
        this.$router.push({name: 'record',query: {e:this.encrypt}})
    },
    login(){
      try{
        let user = JSON.parse(this.base64_decode((this.userMessage).replace(/[ ]/g,'+')));
        if(user.realname && user.mobile && user.scene_id){
          this.realname = user.realname
          this.mobile = user.mobile
          this.scene_id = user.scene_id
          console.log(user)
        }else{
          console.log('不存在realname或mobile或scene_id',user)
          alert('地址有误401')
          return
        }
      }catch(e){
        console.log('参数格式不对:',this.base64_decode(this.userMessage)||'空')
        alert('地址有误402')
        return
      }
      // 若当前用户与上一次登录用户不一致，清空pimcencypt
      if(this.mobile!=this.oldMobile){
        this.pimcencypt = ''
      }
      if(!this.pimcencypt){
        this.getPimcencypt().then((e)=>{
          this.$http.post(`/PcProject/register?${this.getTime()}`,
            {realname:this.realname,mobile:this.mobile,pimcencypt:e}
          ).then(res => {
            if(!res.data.code){
              let e = {scene_id:this.scene_id,user_id:res.data.data.user_id}
              this.encrypt = this.base64_encode(JSON.stringify(e))
              localStorage.setItem("CmindLoginMobile", res.data.data.mobile);
            }
          }).catch(err => {
            alert('登录失败，请检查网络')
          })
        }).catch((err)=>{
          alert(err)
        })
      }else{//存在pimcencypt
        this.$http.get(`/PcProject/checkLogin?${this.getTime()}`,
          {params:{pimcencypt:this.pimcencypt}}
        ).then(res => {
          if(!res.data.code){
            let e = {scene_id:this.scene_id,user_id:res.data.data.user_id}
            this.encrypt = this.base64_encode(JSON.stringify(e))
            localStorage.setItem("CmindLoginMobile", res.data.data.mobile);
          }else if(res.data.code==1){
            this.$http.post(`/PcProject/register?${this.getTime()}`,{
              realname:this.realname,
              mobile:this.mobile,
              pimcencypt:this.pimcencypt
            }).then(res => {
              if(!res.data.code){
                let e = {scene_id:this.scene_id,user_id:res.data.data.user_id}
                this.encrypt = this.base64_encode(JSON.stringify(e))
                localStorage.setItem("CmindLoginMobile", res.data.data.mobile);
              }
            }).catch(err => {
                console.log('register登录接口失败')
            })
          }
        }).catch(err => {
            console.log('checkLogin检查登录接口失败')
        })
      }
    },
    getPimcencypt(){
      return new Promise((resolve, reject)=>{
        this.$http.get(`/PcProject/getencypt`).then(res => {
          if(!res.data.code){
            let pimcencypt = res.data.data.pimcencypt
            localStorage.setItem("pimcencypt", pimcencypt);
            this.pimcencypt = pimcencypt
            resolve(pimcencypt);
          }
        }).catch(err => {
            reject("获取信息失败，请检查网络")
        })
      })
    },
  }
}
</script>
<style scoped>
.check .box{display: flex;padding: 40px 25px;}
.box .left{color: #808080;text-align: left;width: 50%;margin: 0 15px;}
.box .left h2{font-size: 15px;margin-bottom: 10px;text-align: justify;}
.box .left .text{border: 1px solid #ddd;padding: 5px;}
.box .left .text p{font-size: 14px;text-align: justify;line-height: 20px;}
.box .left .text p img{display: inline-block;width: 20px;margin: 0 5px -5px 0;}
.box .right{width: 50%;margin: 0 15px;font-size: 15px;}
.video{
  display: block;width: 340px;margin: 0 auto;
  border: 1px solid #ccc;background: #000;
  height: 200px;
}
#v{width: 200px;}
.btn{
  width: 100%;line-height: 34px;color: #ffffff;
  background: rgba(128,128,128,.8);border: 1px solid #949494;
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.1);
  display: block;text-align: center;border-radius: 4px;
  opacity: 0.8;margin-top: 18px;
}
.enter{
  cursor: pointer;
  background-color: #2fa4e7;border: 1px solid #178acc;
  background-image: linear-gradient(#54b4eb, #2fa4e7 60%, rgba(29,156,229,0.1));
}
.right h3{
  color: #2fa4e7;
  font-size: 15px;line-height: 30px;margin:20px 0 5px;
}
.right h4{
  color: #808080;width: 50%;margin: 5px 0;
  font-size: 15px;line-height: 30px;text-align: left;
}
.right .usable{color: #2fa4e7}
.right img{display: inline-block;width: 20px;margin:0 8px -4px 0;}
.right .device-tip{display: flex;justify-content:space-around;}
</style>



// WEBPACK FOOTER //
// src/components/check.vue